// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CurrentInternalUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentInternalUserQuery = { __typename?: 'Query', currentInternalUser?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string } | null | undefined };


export const CurrentInternalUserDocument = gql`
    query CurrentInternalUser {
  currentInternalUser {
    id
    name
    email
    avatar
  }
}
    `;

/**
 * __useCurrentInternalUserQuery__
 *
 * To run a query within a React component, call `useCurrentInternalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentInternalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentInternalUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentInternalUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>(CurrentInternalUserDocument, options);
      }
export function useCurrentInternalUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>(CurrentInternalUserDocument, options);
        }
export function useCurrentInternalUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>(CurrentInternalUserDocument, options);
        }
export type CurrentInternalUserQueryHookResult = ReturnType<typeof useCurrentInternalUserQuery>;
export type CurrentInternalUserLazyQueryHookResult = ReturnType<typeof useCurrentInternalUserLazyQuery>;
export type CurrentInternalUserSuspenseQueryHookResult = ReturnType<typeof useCurrentInternalUserSuspenseQuery>;
export type CurrentInternalUserQueryResult = Apollo.QueryResult<CurrentInternalUserQuery, CurrentInternalUserQueryVariables>;